import { DateHelper } from '@utils/DateHelper';
import { ENTRY_RESERVATION_INTERVAL } from 'chaika-frontend-types/frontend-cms';

interface DateInterval {
    from: string;
    to: string;
}

export function calculateAvailableReservationDateInterval(entryCreationTime?: string): DateInterval {
    const date = entryCreationTime ?? new Date();

    return {
        from: DateHelper.getStartOfDay(DateHelper.subDays(date, ENTRY_RESERVATION_INTERVAL.From)).toISOString(),
        to: DateHelper.getEndOfDay(date).toISOString(),
    };
}
